/**
 * Feedback Domain Menu Provider
 */

import { IconMessageCircle, IconStar, IconAlertCircle, IconChecks } from '@tabler/icons-react';
import { DomainMenuProvider, MenuItem } from '../../layouts/menu/types';
import { createVisibilityCheck } from './BaseMenuProvider';

class FeedbackMenuProvider implements DomainMenuProvider {
  domainId = 'feedback';

  getMenuConfig() {
    const items: MenuItem[] = [
      {
        id: 'feedback-dashboard',
        label: 'Dashboard',
        path: '/app/feedback',
        icon: <IconMessageCircle size={16} />,
        visible: createVisibilityCheck({ roles: ['Admin'] }),
      },
      {
        id: 'feedback-pending',
        label: 'Pending Review',
        path: '/app/feedback/pending',
        icon: <IconAlertCircle size={16} />,
        visible: createVisibilityCheck({ roles: ['Admin'] }),
        countSelector: () => 15,
        badgeColor: 'orange',
      },
      {
        id: 'feedback-ratings',
        label: 'Ratings',
        path: '/app/feedback/ratings',
        icon: <IconStar size={16} />,
        visible: createVisibilityCheck({ roles: ['Admin'] }),
      },
      {
        id: 'feedback-resolved',
        label: 'Resolved',
        path: '/app/feedback/resolved',
        icon: <IconChecks size={16} />,
        visible: createVisibilityCheck({ roles: ['Admin'] }),
      },
    ];

    return {
      domainId: this.domainId,
      items,
      metadata: {
        version: '1.0.0',
        lastUpdated: Date.now(),
      },
    };
  }
}

export const feedbackMenuProvider = new FeedbackMenuProvider();
